import styles from "./todo.module.css";
import Todo from "./Todo";

const TodoList = ({
  todos,
  deleteHandler,
  handleAddress,
  addressId,
  setIsLoading,
}) => {
  const renderTodos = () => {
    // if (todos.length === 0) return <p>آدرس ایجاد نمایید</p>;

    return todos.map((todo, index) => {
      return (
        <Todo
          key={todo.id}
          todo={todo}
          index={index}
          onDelete={() => deleteHandler(todo.id)}
          // handleAddress={() => handleAddress(todo.id)}
          handleAddress={handleAddress}
          addressId={addressId}
        />
      );
    });
  };

  return <div className={styles.felan}>{renderTodos()}</div>;
};

export default TodoList;
